export default __webpack_public_path__ + "static/7-0df6f53c3f1e489772b4a188bebb152f.jpg";